import useApiMutation from '../useApiMutation';

const useGetCheckout = () => {
  const mutation = useApiMutation({
    getRequestUrl: () => '/customer/checkout',
    method: 'POST',
  });

  return {
    getCheckoutUrl: mutation.mutate,
    isGetCheckoutUrlLoading: mutation.isLoading,
    isGetCheckoutUrlError: mutation.isError,
    isGetCheckoutUrlSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useGetCheckout;
